import { inverseObj, onEscPress, removeElement, setCustomTagHTML } from 'helpers/helpers';
import ResizeObserver from 'resize-observer-polyfill';
import { CarouselImgPreviewTemplate } from './carouselImgPreview.template';

export class CarouselImgPreview {
	constructor(props) {
		this.initData(props);
		this.deletePrevInstance();
		this.initWrapper();
		this.initComponents();
		this.initEventHandlers();
		this.initResizer();
		this.initImgToShowOnOpen();
	}

	initData(propData) {
		this.data = {
			currentSelected: 0,
			carouselViewArea: 0,
			idMap: {},
			idReverseMap: {},
			onCardChange: () => {},
		};
		this.setter(propData);
	}

	deletePrevInstance() {
		const isDialogAlreadyInDOM = document.getElementById('engtMediaOverlay');
		if (isDialogAlreadyInDOM) {
			removeElement(isDialogAlreadyInDOM);
		}
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		wrapper.className = 'engt-media-preview engt-media-controls-wrapper engt-open-preview';
		wrapper.id = 'engtMediaOverlay';
		wrapper.setAttribute('tabindex', 2);
		wrapper.innerHTML = CarouselImgPreviewTemplate(this.data);

		this.previousFocusElement = document.activeElement;
		this.html = wrapper;
	}

	initComponents = () => {
		const { cardImgs = [] } = this.data;
		const ref = this;

		const idMap = {};
		const imageGallery = document.createElement('div');
		imageGallery.className = 'engt-popup-carousel-imgs';

		cardImgs.map(({ url, id }, iterator) => {
			idMap[id] = iterator;
			const imgWrapper = document.createElement('div');
			const img = document.createElement('img');
			img.src = url;
			img.id = `carousel-preview-${id + 1}`;
			img.alt = `img-${id + 1}`;
			img.addEventListener('error', function () {
				ref.removeErrorImg(this);
			});
			imgWrapper.className = 'engt-popup-carousel-img-wrapper';
			imgWrapper.appendChild(img);
			imageGallery.appendChild(imgWrapper);
		});

		this.setter({
			idMap,
			idReverseMap: inverseObj(idMap),
		});
		setCustomTagHTML(this.html.querySelector('list-of-imgs'), imageGallery);
	};

	initEventHandlers = () => {
		const ref = this;
		const { cardImgs } = this.data;
		const leftArrow = this.html.querySelector('.engt-popup-carousel-left');
		const rightArrow = this.html.querySelector('.engt-popup-carousel-right');
		const carousel = ref.html.querySelector('.engt-popup-carousel-imgs');

		this.html.querySelector('.engt-preview-close').addEventListener('click', this.onClose.bind(this));
		this.html.addEventListener('keydown', this.listenForEscape.bind(this));

		if (cardImgs.length <= 1) {
			leftArrow.style.display = 'none';
			rightArrow.style.display = 'none';
		} else {
			leftArrow.addEventListener('click', () => {
				const { currentSelected } = ref.data;
				ref.setter({
					currentSelected: currentSelected - 1 <= 0 ? 0 : currentSelected - 1,
				});
				ref.scrollToActiveImg();
			});
			rightArrow.addEventListener('click', () => {
				const { currentSelected } = ref.data;
				const maxImgs = carousel.children.length;
				ref.setter({
					currentSelected: currentSelected + 1 >= maxImgs - 1 ? maxImgs - 1 : currentSelected + 1,
				});
				ref.scrollToActiveImg();
			});
		}
	};

	initResizer = () => {
		const ref = this;

		new ResizeObserver((entries) => {
			try {
				entries.forEach((e) => {
					const imgs = e.target.children;

					ref.setter({
						carouselViewArea: e.contentRect.width,
					});

					for (let i = 0; i < imgs.length; i++) {
						imgs[i].style.width = `${e.contentRect.width}px`;
						imgs[i].style.minWidth = `${e.contentRect.width}px`;
					}

					ref.scrollToActiveImg();
				});
			} catch (e) {
				console.error('Resizing error in popover carousel -> ', e);
			}
		}).observe(this.html.querySelector('.engt-popup-carousel-imgs'));
	};

	initImgToShowOnOpen = () => {
		const ref = this;
		const { idMap = {}, currentSelected } = ref.data;
		const carousel = this.html.querySelector('.engt-popup-carousel-imgs');

		ref.setter({
			currentSelected: idMap[currentSelected] || 0,
		});

		carousel.style.scrollBehavior = 'unset';
		setTimeout(() => {
			carousel.style.scrollBehavior = 'smooth';
		}, 200);
	};

	removeErrorImg = (errorImage) => {
		if (errorImage) {
			const errorImageParent = errorImage.parentNode;
			errorImageParent.parentNode.removeChild?.(errorImageParent);
			this.toggleArrows();
		}
	};

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	onClose = () => {
		removeElement(this.html);
		this.previousFocusElement?.focus?.();
	};

	listenForEscape = onEscPress(this.onClose);

	scrollToActiveImg = () => {
		const { carouselViewArea, currentSelected, idReverseMap, onCardChange } = this.data || {};
		const carousel = this.html.querySelector('.engt-popup-carousel-imgs');
		carousel.scrollLeft = carouselViewArea * currentSelected;
		this.toggleArrows();
		onCardChange(idReverseMap[currentSelected]);
	};

	toggleArrows() {
		const { currentSelected } = this.data;
		const leftArrow = this.html.querySelector('.engt-popup-carousel-left');
		const rightArrow = this.html.querySelector('.engt-popup-carousel-right');
		const carousel = this.html.querySelector('.engt-popup-carousel-imgs');
		const maxImgs = carousel.children.length;

		if (currentSelected === 0) {
			this.disableArrow(leftArrow);
			this.enableArrow(rightArrow);
		} else if (currentSelected === maxImgs - 1) {
			this.disableArrow(rightArrow);
			this.enableArrow(leftArrow);
		} else {
			this.enableArrow(leftArrow);
			this.enableArrow(rightArrow);
		}
	}

	disableArrow = (arrow) => {
		arrow.setAttribute('disabled', true);
	};

	enableArrow = (arrow) => {
		arrow.removeAttribute('disabled');
	};

	render() {
		document.getElementById('engtWrapper').appendChild(this.html);
		this.html.focus();
		return this.html;
	}
}
